// extracted by mini-css-extract-plugin
export var layout = "Tabs-module--layout--dc0c5";
export var list = "Tabs-module--list--32041";
export var panel = "Tabs-module--panel--74d14";
export var tab = "Tabs-module--tab--149c8";